<template>
  <div class="content has-text-centered relative">
    <RegisterAll v-if="showRegisterForm" :translations="translations" :legalType="legalType" :upgrade="upgrade" :accountType="type" :detectedCountry="detectedCountry" />

    <!-- <live
      :translations="translations"
      :step="step"
      :legalType="legalType"
      :upgrade="upgrade"
      v-if="$route.meta.registerComponent == 'Live' || $route.meta.registerComponent == 'Upgrade-live'"
    ></live> -->
    <!--
    <demo :translations="translations" :step="step" :legalType="legalType" v-if="$route.meta.registerComponent == 'Demo'"></demo>
    <partner :translations="translations" :step="step" :legalType="legalType" v-if="$route.meta.registerComponent == 'Partner'"></partner> -->

    <logo-loader v-if="logoLoaderActive" :text="logoLoaderText"></logo-loader>
    <div class="hidden lg:block absolute ltr:right-6 rtl:left-6 top-2">
      <language-popover></language-popover>
    </div>

    <div v-if="TwoFactorAuthStep1.active || TwoFactorAuthStep2.active">
      <div class="flex flex-wrap justify-center bg-blue" style="height: 70px">
        <a href="/" class="flex items-center">
          <img width="176" src="../../assets/img/plexytrade-logo-white.svg" />
        </a>
      </div>
      <div class="flex m-auto" :class="[TwoFactorAuthStep1.active ? 'md:h-calc1' : 'h-calc1']">
        <two-factor-modal-step-1
          v-if="TwoFactorAuthStep1.active"
          :TwoFactorAuthStep1="TwoFactorAuthStep1"
          @twoFactorStep2="showTwoFactorAuthStep2"
          @back="backToLogin"
          class="py-12 md:py-28 lg:py-12 md:m-auto"
        ></two-factor-modal-step-1>

        <two-factor-modal-step-2
          v-if="TwoFactorAuthStep2.active"
          :TwoFactorAuthStep2="TwoFactorAuthStep2"
          :data="TwoFactorAuthStep2.data"
          :is2FASetup="is2FASetup"
          @back="goBack"
          class="m-auto"
        ></two-factor-modal-step-2>
      </div>
      <div class="fixed bottom-0 w-full z-20">
        <div class="m-auto table max-w-[1399px] w-full">
          <footer-collapsible></footer-collapsible>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Live from './Live.vue'
// import Demo from './Demo.vue'
// import Partner from './Partner.vue'
import RegisterAll from './RegisterAll.vue'
import { service } from '../../main.js'
import { mapGetters, mapActions } from 'vuex'
import { Validator } from 'vee-validate'
import config from '../../config'
import { Base64 } from 'js-base64'
import LogoLoader from '../../components/LogoLoader.vue'
import LanguagePopover from '../../components/Language.vue'
import links from '../../config/links'
import TwoFactorModalStep1 from '@/components/2FA/Step1.vue'
import TwoFactorModalStep2 from '@/components/2FA/Step2.vue'
import FooterCollapsible from '@/components/FooterCollapsible.vue'

export default {
  components: {
    // Live,
    // Demo,
    // Partner,
    LogoLoader,
    RegisterAll,
    LanguagePopover,
    TwoFactorModalStep1,
    TwoFactorModalStep2,
    FooterCollapsible,
  },
  data() {
    return {
      logID: 0,
      step: 1,
      skipStep: null,
      type: this.$route.meta.registerComponent.toLowerCase(),
      upgrade: false,
      userID: false,
      legalType: 'individual',
      isLead: false,
      formData: {},
      translations: {
        months: {},
        genders: {},
        text: {},
      },
      loadingNextStep: false,
      blockFlag: false,
      detectedCountry: null,
      TwoFactorAuthStep1: {
        active: false,
        totp: '',
      },
      TwoFactorAuthStep2: {
        active: false,
        data: {},
      },
      showRegisterForm: true,
      is2FASetup: false,
    }
  },
  watch: {
    Language(l) {
      if (l !== null && typeof l !== 'undefined') {
        Validator.localize(l)
        this.setTranslations()
      }
    },
    'BonusConfig.noDepositBonus.enabled'() {
      if (this.BonusConfig.noDepositBonus.enabled) {
        if (this.$route.query.ndbonus === '1') {
          this.$bus.$emit('grantNoDepositBonus', true)
        }
      }
    },
  },
  computed: {
    TOSURL() {
      return links.getLink('companyLegalDoc', 'en')
    },
    bonusTOSURL() {
      return config.URL.website + ''
    },
    noDepositBonusURL() {
      return links.getLink('noDepositBonusURL', 'en')
    },
    plexypowerBonusURL() {
      return links.getLink('plexypowerBonusURL', 'en')
    },
    LPOA_URL() {
      return links.getLink('acceptTheLpoa', 'en')
    },
    PrivacyURL() {
      return links.getLink('privacyPolicy', 'en')
    },
    termsAndConditionsURL() {
      return links.getLink('termsOfService', 'en')
    },
    bonusTermsLink() {
      return links.getLink('bonusTermsConditions', 'en')
    },
    riskDisclosureURL() {
      return config.URL.website + ''
      // return config.URL.website + 'pdf/' + this.Language + '/legal-risk-disclosure.pdf'
    },
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      BonusConfig: 'bonusconfig/all',
      logoLoaderActive: 'logoLoader/active',
      logoLoaderText: 'logoLoader/text',
    }),
  },
  mounted() {
    // legacy redirection links
    if (this.$route.query.refid !== undefined) {
      // get first ib code
      const IBID = parseInt(this.$route.query.refid)
      service
        .get('/ib/legacy/get-first-code', {
          params: {
            ibid: IBID,
          },
        })
        .then(response => {
          // redirect a couple times :)
          window.location = `/${this.Language}/ib/r?t=${response.data.tracking_link}`
        })

      return
    }

    if (this.type === 'upgrade-live') {
      if (this.$store.state.user.info.ID <= 0) {
        // needs to be logged in
        this.$toasted.error(this.$t('invalid_request_login_required') + '<span class="error-id"></span>')
        this.$router.push('/' + this.Language + '/login')
        return
      }
      if ('live'.indexOf(this.User.accountTypes) !== -1) {
        // already a live account
        this.$toasted.error(this.$t('error_live_account_already') + '<span class="error-id"></span>')
        this.$router.push('/' + this.Language + '/')
        return
      }
      this.upgrade = true
      this.type = 'live'
      this.userID = this.$store.state.user.info.ID
    }
    if (this.type === 'live' || this.type === 'demo') {
      // Recover the IB code from the URL or any persisted store, then rely on storage
      // (and strip `t` from the URL once stored).
      const trackingCode = this.$route.query.t || this.$getReferralCode()
      if (trackingCode) {
        this.$setReferralCode(trackingCode)
      }
      if (this.$route.query.t) {
        history.replaceState({}, this.$route.name, this.$route.path)
      }
      this.handleQuery()
    }
    this.setTranslations()
    Validator.localize(this.Language)
    this.$bus.$on('Complete', this.onComplete)
    this.$bus.$on('NextStep', this.onNextStep)
    this.$bus.$on('PreviousStep', this.onPreviousStep)
    this.$bus.$on('SelectLegalType', this.onSelectLegalType)

    if (this.type == 'live') {
      this.$bus.$emit('ChangeHeadings', this.$t('register_live_account').tTitle(), this.$t('live_account') + ' | ' + this.$t('app_name'))
    } else if (this.type == 'demo') {
      this.$bus.$emit('ChangeHeadings', this.$t('register_demo_account').tTitle(), this.$t('demo_account') + ' | ' + this.$t('app_name'))
    } else if (this.type == 'partner') {
      this.$bus.$emit('ChangeHeadings', this.$t('register_partner_account').tTitle(), this.$t('partner_account') + ' | ' + this.$t('app_name'))
    }
    this.addMeta('ogtitle', this.$t('register').tCapitalizeFirstLetter() + ' | ' + this.$t('app_name'))
    this.addMeta('description', this.$t('register_description'))
    this.addMeta('canonical', config.URL.cp + this.$route.path)
    this.addMeta('alternate', this.$route.meta.identifierPath)

    // Fetch detected country from IP for preselection in registration form
    if (!this.upgrade) {

      service
        .get('https://api.country.is/')
        .then(response => {
          const country = response?.data?.country
          // Validate country is a valid 2-letter code
          if (country && typeof country === 'string' && country.length === 2) {
            this.detectedCountry = country
          } else {
            this.detectedCountry = null
          }
        })
        .catch(error => {
          console.error('Failed to detect country:', error)

          fetch('https://get.geojs.io/v1/ip/country.json')
          .then(res => res.json())
          .then(data => {
            const country = data?.country
            // Validate country is a valid 2-letter code
            if (country && typeof country === 'string' && country.length === 2) {
              this.detectedCountry = country
            } else {
              this.detectedCountry = null
            }
          })
          .catch(error => {
            console.error('Failed to detect geo country:', error)
            this.detectedCountry = null
          })
        })
    }
  },
  created() {
    if (this.type === 'upgrade-live' && this.$store.state.user.info.ID > 0 && 'live'.indexOf(this.User.accountTypes) === -1) {
      this.upgrade = true
      this.type = 'live'
      this.userID = this.$store.state.user.info.ID
    }
  },
  beforeDestroy() {
    this.$bus.$off('Complete', this.onComplete)
    this.$bus.$off('NextStep', this.onNextStep)
    this.$bus.$off('PreviousStep', this.onPreviousStep)
    this.$bus.$off('SelectLegalType', this.onSelectLegalType)
  },
  methods: {
    handleQuery() {
      // for simple lead
      if (Object.keys(this.$route.query).length > 0) {
        let required = ['title', 'first_name', 'last_name', 'email', 'phone']
        let leadData = {}
        for (let v of required) {
          if (this.$route.query[v] === '') {
            return
          }
          leadData[v] = this.$route.query[v]
        }
        // country code uppercase
        // this.$route.query['country'] = this.$route.query['country'].toUpperCase()
        // log
        this.isLead = true
        this.$bus.$emit('isLead', this.isLead)
        let data = {
          ID: this.logID,
          type: this.type,
          step: this.step,
          legalType: this.legalType,
          formData: leadData,
          isLead: this.isLead,
        }
        // log here
        service.post('/users/create/log', data).then(response => {
          this.logID = response.data.ID
        })
      }
    },
    onComplete(formData) {
      if (this.blockFlag) return
      this.blockFlag = true

      if (this.legalType === 'company') {
        formData.first_name = ''
        formData.middle_name = ''
        formData.last_name = ''
        formData.gender = ''
      } else if (this.legalType === 'individual') {
        formData.company_name = ''
        formData.website = ''
        formData.numberOfDirectors = 0
        formData.numberOfShareholders = 0
        delete formData.shareholders
        delete formData.directors
        delete formData.activeDirector
        delete formData.activeShareholder
      }

      // registration date for statistic
      formData.submitDate = new Date().toISOString().slice(0, 19).replace('T', ' ')
      formData.supportedCountry = true

      let data = {
        ID: this.logID,
        type: this.type,
        step: this.step,
        legalType: this.legalType,
        formData: formData,
        isLead: this.isLead,
        campaignName: '',
      }

      this['logoLoader/setManualLoader'](true)

      // Use already-fetched detectedCountry from IP
      const detectedCountry = this.detectedCountry
      // const refCode = this.$getCookie('refcode')
      const selectedCountry = data.formData.country
      formData.countryID = detectedCountry

      // create Log
      service
      .post('/users/create/log', data)
      .then(response => {
        data.userIP = response.data.UserIP
        this.logID = response.data.ID
        const refCode = this.$route.query.t || this.$getReferralCode()

        data.ID = this.logID
        data.IBCode = refCode
        data.CXToken = this.$getCookie('cx_token') === undefined ? '' : this.$getCookie('cx_token')
        data.campaignName = window.localStorage.getItem('campaign_name') === null ? '' : window.localStorage.getItem('campaign_name')
        data.affID = parseInt(this.$getCookie('aff_id'))
        data.device = '-'
        data.lang = this.Language

        if (data.formData.startingDemoBalance && data.formData.startingDemoBalance !== '') {
          data.formData.startingDemoBalance = parseFloat(data.formData.startingDemoBalance)
        }

        var firstNameMiddleName = data.formData.first_name.split(/(?<=^\S+)\s/)
        data.formData.first_name = firstNameMiddleName[0]
        if (firstNameMiddleName.length > 1) {
          data.formData.middle_name = firstNameMiddleName[1] + ' ' + data.formData.middle_name
        }

        if (!this.upgrade) {
          // If detectedCountry is null/undefined (API failed), treat it as restricted
          if (!detectedCountry) {
            this['logoLoader/setManualLoader'](false)
            this.$toasted.error(this.$t('country_not_supported'))
            this.blockFlag = false
            formData.supportedCountry = false
            return
          }

          const isRestricted = [detectedCountry, selectedCountry].some(c => config.blockCountriesUponRegistration.includes(c))

          if (isRestricted) {
            service
              .post('/ib/whitelisted', { code: refCode })
              .then(whitelistResponse => {
                if (!whitelistResponse.data.whitelisted) {
                  this['logoLoader/setManualLoader'](false)
                  this.$toasted.error(this.$t('country_not_supported'))

                  this.blockFlag = false
                  formData.supportedCountry = false
                } else {
                  this.proceedWithRegistration(formData, data)
                }
              })
              .catch(error => {
                this['logoLoader/setManualLoader'](false)
                this.blockFlag = false
                formData.supportedCountry = false
                if (typeof error.response !== 'undefined') {
                  if (typeof error.response.data !== 'undefined') {
                    if (typeof error.response.data.meta.messageID !== 'undefined') {
                      this.$toasted.error(this.$t(error.response.data.meta.messageID).tTitle())
                    } else {
                      this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>')
                    }
                  }
                } else {
                  console.error('Whitelist API error:', error)
                  this.$toasted.error(this.$t('error_contact_support'))
                }
                // Registration stops here (proceedWithRegistration not called)
              })
          } else {
            this.proceedWithRegistration(formData, data)
          }
        } else {
          this.proceedWithRegistration(formData, data)
        }

      })
      .catch(error => {
        this['logoLoader/setManualLoader'](false)
        if (typeof error.response !== 'undefined') {
          this.blockFlag = false
          if (typeof error.response.data !== 'undefined') {
            if (typeof error.response.data.meta.messageID !== 'undefined') {
              this.$toasted.error(this.$t(error.response.data.meta.messageID).tTitle())
            } else {
              this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>')
            }
          }
        }
      })


    },
    proceedWithRegistration(formData, data) {

      // upgrade url
      let url = '/users/create/'
      if (this.upgrade) {
        url = '/users/upgrade/'
        data.userID = this.userID
      }

      service.post(url + this.type.toLowerCase(), data).then(response => {
        if (!response.data.success) {
          if (response.data.errors) {
            let errk = Object.keys(response.data.errors)
            for (let i = 0; i < errk.length; i++) {
              if (this.translations.text[errk[i]]) {
                if (response.data.errors[errk[i]] === 'required') {
                  this.$toasted.error(this.$t('error_missing_required_field') + this.translations.text[errk[i]] + '"')
                }
              }
            }
          } else {
            this.$toasted.error(this.$t('error_contact_support'))
          }
          return
        }

        if (this.upgrade) {
          if (response.data.success) {
            this['user/reset']()
            this['user/setInfo']({ ID: this.userID })
            this.$router.push({ path: '/' + this.Language + '/' + config.defaultURL, query: { upgrade: true } }).catch(() => {})
            this.$gtag.event('upgrade_to_live', {
              event_category: 'onboarding',
              event_label: 'Upgrade to live',
            })
          }
        } else {
          this.showRegisterForm = false
          this.TwoFactorAuthStep1.active = true
          this.TwoFactorAuthStep1.totp = response.data.totp
          this.TwoFactorAuthStep2.data = data.formData
          this['logoLoader/setManualLoader'](false)
          // this.login(data.formData.email, data.formData.password, data.formData.recaptchaToken)
          // this.$gtag.event('sign_up_' + this.type, {
          //   event_category: 'onboarding',
          //   event_label: 'sign up ' + this.type,
          // })
        }
      })
      .catch(error => {
        this['logoLoader/setManualLoader'](false)
        if (typeof error.response !== 'undefined') {
          if (typeof error.response.data !== 'undefined') {
            if (typeof error.response.data.meta.messageID !== 'undefined') {
              this.$toasted.error(this.$t(error.response.data.meta.messageID).tTitle())
            } else {
              this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>')
            }
          }
        }
      })

    },
    login(email, password, recaptchaToken) {
      this.$auth
        .login({
          url: config.API.host + 'authenticate/login?isClient=1',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + Base64.encode(email.trim() + ':' + password + ':' + recaptchaToken),
          },
          redirect: {
            name: 'Dashboard | English',
          },
          staySignedIn: true,
        })
        .then(
          response => {
            // Success
            this.$auth.fetch().then(() => {
              // Success
              this.$bus.$emit('LiveFeedConnect')
            })
            if (response.data.totp == '') {
              this.is2FASetup = true
              this.showTwoFactorAuthStep2()
            } else {
              this.is2FASetup = false
              this.check2FA(response.data.totp)
            }
          },
          err => {
            // Error
            if (err.response) {
              this.error = err.response.data
              this.$store.state.token = null
            }
          }
        )
    },
    onNextStep(formData) {
      if (this.loadingNextStep) {
        return
      }
      this.loadingNextStep = true

      let typeLog = this.type
      if (this.upgrade) {
        typeLog = 'upgrade-' + typeLog
        formData.userID = this.userID
      }
      let data = {
        ID: this.logID,
        type: typeLog,
        step: this.step,
        legalType: this.legalType,
        formData: formData,
        isLead: this.isLead,
      }
      // log here
      service
        .post('/users/create/log', data)
        .then(response => {
          this.logID = response.data.ID

          this.step++
          while (this.step === this.skipStep) {
            this.step++
          }
          window.scroll(0, 0)
          this.loadingNextStep = false
        })
        .catch(() => {
          this.loadingNextStep = false
        })
    },
    onPreviousStep() {
      this.step--
      while (this.step === this.skipStep) {
        this.step--
      }
    },
    onSelectLegalType(type) {
      this.legalType = type
    },
    setTranslations() {
      this.translations.months = [
        { value: 1, label: this.$t('january').tTitle() },
        { value: 2, label: this.$t('february').tTitle() },
        { value: 3, label: this.$t('march').tTitle() },
        { value: 4, label: this.$t('april').tTitle() },
        { value: 5, label: this.$t('may').tTitle() },
        { value: 6, label: this.$t('june').tTitle() },
        { value: 7, label: this.$t('july').tTitle() },
        { value: 8, label: this.$t('august').tTitle() },
        { value: 9, label: this.$t('september').tTitle() },
        { value: 10, label: this.$t('october').tTitle() },
        { value: 11, label: this.$t('november').tTitle() },
        { value: 12, label: this.$t('december').tTitle() },
      ]
      this.translations.genders = [
        { value: 'male', label: this.$t('male').tTitle() },
        { value: 'female', label: this.$t('female').tTitle() },
        { value: 'other', label: this.$t('gender_other').tTitle() },
      ]
      this.translations.text = {
        title: this.$t('title').tTitle(),
        first_name: this.$t('first_name').tTitle(),
        middle_name: this.$t('middle_name').tTitle(),
        last_name: this.$t('last_name').tTitle(),
        email: this.$t('email_address').tTitle(),
        dial_code: this.$t('dial_code').tTitle(),
        phone: this.$t('phone_number').tTitle(),
        country: this.$t('country').tTitle(),
        country_of_residence: this.$t('country_of_residence').tTitle(),
        date_of_birth: this.$t('date_of_birth').tTitle(),
        day: this.$t('day').tTitle(),
        month: this.$t('month').tTitle(),
        year: this.$t('year').tTitle(),
        nationality: this.$t('nationality').tTitle(),
        gender: this.$t('gender').tTitle(),
        address: this.$t('address_line').tTitle(),
        address2: this.$t('address_line_2').tTitle(),
        address_placeholder: this.$t('address_placeholder'),
        post_code: this.$t('post_code').tTitle(),
        post_zip_code: this.$t('post_zip_code'),
        city: this.$t('city_town').tTitle(),
        state_province: this.$t('state_province').tTitle(),
        year_moved_to_address: this.$t('year_moved_to_address').tTitle(),
        website: this.$t('website').tTitle(),
        social_media: this.$t('social_media').tTitle(),
        password: this.$t('password').tTitle(),
        confirm_password: this.$t('confirm_password').tTitle(),
        social_platform: this.$t('social_platform').tTitle(),
        other_social_platform: this.$t('other_social_platform').tTitle(),
        total_estimated_net_worth: this.$t('total_estimated_net_worth').tTitle(),
        select_option: this.$t('select_option').tTitle(),
        total_estimated_annual_income: this.$t('total_estimated_annual_income').tTitle(),
        employment_status: this.$t('employment_status').tTitle(),
        employed: this.$t('employed').tTitle(),
        self_employed: this.$t('self_employed').tTitle(),
        retired: this.$t('retired').tTitle(),
        student: this.$t('student').tTitle(),
        unemployed: this.$t('unemployed').tTitle(),
        source_of_income: this.$t('source_of_income').tTitle(),
        employment: this.$t('employment').tTitle(),
        inheritance: this.$t('inheritance').tTitle(),
        investment: this.$t('investment').tTitle(),
        other: this.$t('other_text').tTitle(),
        forex_cfds_and_other_instruments: this.$t('forex_cfds_and_other_instruments').tTitle(),
        yes: this.$t('yes').tTitle(),
        no: this.$t('no').tTitle(),
        lose_capital_risk: this.$t('lose_capital_risk').tTitle(),
        prev_pro_qualifications: this.$t('prev_pro_qualifications').tTitle(),
        choose_trading_platform: this.$t('choose_trading_platform').tTitle(),
        platform: this.$t('platform').tTitle(),
        account_type: this.$t('account_type').tTitle(),
        choose_currency: this.$t('account_currency').tTitle(),
        include_account_in_bonus_program: this.$t('include_account_in_bonus_program', { bonusTermsURL: this.bonusTermsLink }).tTitle(),
        agree_with_no_deposit_bonus: this.$t('agree_with_no_deposit_bonus', { URL: this.noDepositBonusURL }).tTitle(),
        agree_with_plexypower_bonus: this.$t('agree_with_plexypower_bonus', { URL: this.plexypowerBonusURL }).tTitle(),
        i_accept_the_lpoa: this.$t('read_and_accept_lpoa', { URL: this.LPOA_URL }).tTitle(),
        read_and_accept_lpoa: this.$t('read_and_accept_lpoa', { URL: this.LPOA_URL }).tTitle(),
        company_name: this.$t('company_name').tTitle(),
        date_of_registration: this.$t('date_of_registration').tTitle(),
        number_of_shareholders: this.$t('number_of_shareholders').tTitle(),
        number_of_directors: this.$t('number_of_directors').tTitle(),
        target_geo_location: this.$t('what_geographic_region').tTitle(),
        company_website: this.$t('company_website').tTitle(),
        not_required: this.$t('not_required').tTitle(),
        tos_with_link: this.$t('tos_with_link', { URL: this.TOSURL }).tTitle(),
        bonus_tos_with_link: this.$t('bonus_tos_with_link', { URL: this.bonusTOSURL }).tTitle(),
        i_am_over_18: this.$t('i_am_over_18').tTitle(),
        select_starting_balance: this.$t('select_starting_balance', { URL: this.bonusTOSURL }).tTitle(),
        data_policy_text: this.$t('data_policy_text', { TERMS_CONDITIONS_URL: this.termsAndConditionsURL, RISK_DISCLOSURE_URL: this.riskDisclosureURL }).tTitle(),
        firstname_placeholder: this.$t('firstname_placeholder').tTitle(),
        middlename_placeholder: this.$t('middlename_placeholder').tTitle(),
        lastname_placeholder: this.$t('lastname_placeholder').tTitle(),
        optional: this.$t('optional').tTitle(),
        privacy_policy_link: this.$t('privacy_policy_link', { URL: this.PrivacyURL }).tTitle(),
        marketing_link: this.$t('marketing_checkbox').tTitle(),
        terms_link: this.$t('terms_link', { URL: this.termsAndConditionsURL }).tTitle(),
        trading_account_currency: this.$t('trading_account_currency').tTitle(),
        account_balance: this.$t('account_balance').tTitle(),
        wallet_currency: this.$t('wallet_currency').tTitle(),
        trading_account_type: this.$t('trading_account_type').tTitle(),
        company_name_placeholder: this.$t('company_name_placeholder'),
        leverage: this.$t('leverage'),
      }
    },
    showTwoFactorAuthStep2() {
      this.showRegisterForm = false
      this.TwoFactorAuthStep1.active = false
      //this.TwoFactorAuthStep1.totp = ''
      this.TwoFactorAuthStep2.active = true
      // console.log(this.TwoFactorAuthStep2.data)
    },
    goBack(v) {
      if (v) {
        this.showLoginForm = true
        this.TwoFactorAuthStep1.active = false
        this.TwoFactorAuthStep2.active = false
      } else {
        this.TwoFactorAuthStep1.active = true
        this.TwoFactorAuthStep2.active = false
      }
    },
    backToLogin() {
      this.$auth
        .logout({
          makeRequest: false,
          params: {},
          redirect: '/' + this.Language + '/login',
        })
        .then(() => {
          this['user/reset']()
        })
    },
    ...mapActions(['user/reset', 'user/setAccountTypes', 'user/set', 'user/setInfo', 'logoLoader/setManualLoader']),
  },
}
</script>
